import { useSelector } from "react-redux";
import { AppState } from "types/AppState";

export const shouldUseStreamingPlayer = ({ player }: AppState): boolean =>
  player.streaming;

export const useStreamingPlayer = (): boolean =>
  useSelector(shouldUseStreamingPlayer);

export const shouldShowVideoPreview = ({ player }: AppState): boolean =>
  player.showVideoPreview;

export const useVideoPreviewEnabled = (): boolean =>
  useSelector(shouldShowVideoPreview);
